/**
 * Web: hand the user a downloaded copy of their local actor data.
 *
 * The serialization itself is platform-neutral and lives in
 * `build-actor-data-export.ts`; only the download is web-specific.
 */

/** Trigger a browser download of an export produced by `buildActorDataExport`. */
export function downloadActorDataExport(ndjson: string, filename: string): void {
  const blob = new Blob([ndjson], { type: "application/x-ndjson" });
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    // Revoking immediately is safe: the click has already handed the blob to the
    // download manager.
    URL.revokeObjectURL(url);
  }
}
